// The bookings either side of a slot on one aircraft, so someone choosing a
// time sees who flies before and after them (and how much room there is).
// Pure: the form passes the bookings it has already loaded.

export interface NeighbourCandidate {
  bookingId: number
  registration: string
  kind: string
  status: string
  startsAt: string
  endsAt: string
}

export interface Neighbours<T extends NeighbourCandidate> {
  previous: T | null
  next: T | null
}

export function neighbouringBookings<T extends NeighbourCandidate>(
  bookings: readonly T[],
  registration: string,
  window: { startsAt: Date; endsAt: Date },
  excludeBookingId?: number,
): Neighbours<T> {
  const start = window.startsAt.getTime()
  const end = window.endsAt.getTime()
  let previous: T | null = null
  let next: T | null = null

  for (const booking of bookings) {
    // Only what holds the aircraft: a standby never does, and the booking
    // being edited is not its own neighbour.
    if (booking.registration !== registration) continue
    if (booking.kind !== 'reservation' || booking.status !== 'active') continue
    if (booking.bookingId === excludeBookingId) continue

    const bookingStart = new Date(booking.startsAt).getTime()
    const bookingEnd = new Date(booking.endsAt).getTime()
    // Half-open, like the database: one ending when this starts is adjacent,
    // not overlapping. Anything that overlaps is a conflict, not a neighbour.
    if (bookingEnd <= start) {
      if (!previous || bookingEnd > new Date(previous.endsAt).getTime()) previous = booking
    } else if (bookingStart >= end) {
      if (!next || bookingStart < new Date(next.startsAt).getTime()) next = booking
    }
  }
  return { previous, next }
}
